export default {
  editBasicDetails: "editBasicDetails",
  editQualifications: "editQualifications",
  removeUserData: "removeUserData",
};
